




















































































































































































































































































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import store from "@/store";
import QFloorSelect from "@/common/qFloorSelect.vue";
import QErrors from "@/common/qErrors.vue";
import QCompanySelect from "@/common/qCompanySelect.vue";
import QUserSelect from "@/common/qUserSelect.vue";
import postalCodeApi from "@/api/postalCodeApi";
import Property from "@/model/property";
import Location from "@/model/location";
import DateTimeGenerator from "@/common/mixins/dateTimeGenerator";
import FloorPlan from "@/model/floor";
import propertyApi from "@/api/propertyApi";
import qNotify from "@/common/qNotify";
import PropertyList from "@/components/property/propertyList.vue";
import _ from "lodash";
import {compareWithKeys, removeNullOrEmpty} from "@/common/utils";
import QTableHeader from "@/common/qTableHeader.vue";
import Company from "@/model/company";
import { namespace } from "vuex-class";
import moment from "moment";
import QSelect2 from "@/common/qSelect2.vue";
const routerStore = namespace("Router");
const auth = namespace("Auth");
@Component({
  name: "PropertyBulkEdit",
  directives: {},
  components: {
    QFloorSelect,
    QErrors,
    QCompanySelect,
    QUserSelect,
    PropertyList,
    QTableHeader,
    QSelect2,
  },
})
export default class PropertyBulkEdit extends Mixins(DateTimeGenerator) {
  @auth.Getter
  getCurrentyCompany!: Company;
  @routerStore.Getter
  public getSearchParameters!:any;

  public propertyObject = new Property();
  public propertyObjectInit = new Property();
  public errors = {};
  public listYear = this.getYears();
  public listMonth = this.getMonths();
  public listDay = this.getDays();
  public year = null;
  public month = null;
  public day = null;
  public headers = [
    { id: "manage_number", name: "管理番号", order: "desc" },
    { id: "", name: "所在地" },
    { id: "", name: "名称" },
  ];
  public yearConfig = {
    width: '100px',
    tags: true,
  };
  @Prop({ default: null })
  companyOwnerId

  mounted() {
    this.propertyObject.type = null;
    this.propertyObject.allow_change = null;
    if (this.propertySelected.length === 0) {
      this.$router.push({ name: "admin.property", query: this.getSearchParameters ? this.getSearchParameters.propertyList : null });
    }
    this.checkHistory();
    this.propertyObjectInit = _.cloneDeep(this.propertyObject)
  }

  get manageCompanyId() {
    return this.getCurrentyCompany ? this.getCurrentyCompany.id : null;
  }

  public checkHistory() {
    const result = store.state.Property.property;
    if (result) {
      this.$modal.show({
        text: this.$t("recover"),
        onConfirm: () => {
          this.propertyObject = result;
          store.dispatch("Property/setProperty", null);
        },
        onClose: () => {
          store.dispatch("Property/setProperty", null);
        },
      });
    }
  }

  get propertySelected(): [] {
    return store.state.Property.propertySelected || [];
  }

  get propertySelectedId() {
    return this.propertySelected.map((item: any) => item.id);
  }

  public changeFloor(floor) {
    this.propertyObject.floor_plan = floor || new FloorPlan();
  }

  public addFloor() {
    // { name: 'admin.floor-create' }
    // dispatch('ride/clearUserData', null, { root: true })
    store.dispatch("Property/setProperty", this.propertyObject);
    // console.log(this.$store.state);    // this.$router.push({ name: "admin.floor-create" });
    this.$router.push({ name: "admin.floor-create" });
  }

  public changeDateOfConstruction() {
    if (moment(`${this.year}-${this.month}-${this.day}`, 'YYYY-M-D', true).isValid()) {
      this.propertyObject.date_of_construction = `${this.year}-${this.month}-${this.day}`;
    } else {
      this.propertyObject.date_of_construction = 'INVALID_DATE';
    }
  }

  public async getPostalCode() {
    if (this.propertyObject.zip_code.trim() === "") {
      this.propertyObject.location = new Location();
      this.errors = {};
      return;
    }

    const result = await postalCodeApi.show(this.propertyObject.zip_code);
    if (result) {
      this.propertyObject.location = result;
      this.errors = {};
    } else {
      this.propertyObject.location = new Location();
      this.errors = {
        zip_code: [this.$t("common.zip_code_not_found")],
      };
    }
  }
  public cancel() {
    if (this.isChangedProperty()) {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.$router.push({ name: "admin.property", query: this.getSearchParameters ? this.getSearchParameters.propertyList : null });
        },
        onClose: () => {
          console.log("onClose");
        },
      });
    } else {
      this.$router.push({ name: "admin.property", query: this.getSearchParameters ? this.getSearchParameters.propertyList : null });
    }
  }

  public isChanged() {
    const dataProperty = removeNullOrEmpty(this.propertyObject);
    return !_.isEmpty(dataProperty);
  }

  public isChangedProperty() {
    return compareWithKeys(this.propertyObject, this.propertyObjectInit, [
      'name',
      'zip_code',
      'company_id',
      'exact_address',
      'owner_company_id',
      'person_in_charge_id',
      'date_of_construction',
      'floor_plan_id',
      'floor_plan.id',
      'structure',
      'acreage',
      'floor_plan_type',
      'remarks',
    ])
  }

  public async submit() {
    if (this.isChanged()) {
      if (this.companyOwnerId) {
        this.propertyObject.owner_company_id = this.companyOwnerId;
        this.propertyObject.company_id = this.manageCompanyId;
      }
      const result = await propertyApi.bulkUpdate(
        this.propertySelectedId,
        this.propertyObject
      );
      if (result.meta.status === 200) {
        qNotify.success({
          text: this.$t("properties.bulk_edit_success"),
        });
        this.$router.push({ name: "admin.property", query: this.getSearchParameters ? this.getSearchParameters.propertyList : null });
      } else {
        this.errors = result.meta.errors;
        qNotify.error({
          text: result.meta.message,
        });
      }
    } else {
      qNotify.error({
        text: this.$t("properties.bulk_edit_not_change"),
      });
    }
  }
  public changeSelfServe() {
    if (this.propertyObject.self_serve) {
      this.propertyObject.owner_company_id = null;
      this.propertyObject.person_in_charge_id = null;
    }
  }

  @Watch('month')
  public async updateChangeDateListByMonth() {
    let result;
    if (this.year !== null) {
      result = await this.getDateListByChangeDate(this.year + '-' + this.month);
    } else {
      result = this.getDays()
    }

    this.listDay = result
  }

  @Watch('year')
  public async updateChangeDateListByYear() {
    let result;
    if (this.month !== null) {
      result = await this.getDateListByChangeDate(this.year + '-' + this.month);
    } else {
      result = this.getDays()
    }

    this.listDay = result
  }
}
